module.exports = __webpack_public_path__ + "static/media/mindfulness@3x.c789b2ba.png";